/**
 * Matchmaking strategy declared on map config entries.
 * MMS queue workers dispatch tickets by this value.
 */
export enum MatchmakingStrategy {
  IMMEDIATE_LOBBY_MATCH = 'immediate_lobby_match',
  QUEUED_TEAM_MATCH = 'queued_team_match'
}

/** How MMS groups tickets by player scope for a map. */
export type MatchmakingScopePolicy = 'configured_scope' | 'prefer_class_during_school_hours';

export interface IMatchmakingConfig {
  strategy: MatchmakingStrategy;
  maxWaitTimeMs?: number;
  scopePolicy?: MatchmakingScopePolicy;
}

/** GES-side match prep options declared on map config entries. */
export interface IEnginePrepConfig {
  fillEmptySlotsWithAi?: boolean;
}

export function isMatchmakingStrategy(value: unknown): value is MatchmakingStrategy {
  return value === MatchmakingStrategy.IMMEDIATE_LOBBY_MATCH
    || value === MatchmakingStrategy.QUEUED_TEAM_MATCH;
}
